import { render, staticRenderFns } from "./groupBuyingAdminView.vue?vue&type=template&id=4c166562&"
import script from "./groupBuyingAdminView.vue?vue&type=script&lang=js&"
export * from "./groupBuyingAdminView.vue?vue&type=script&lang=js&"
import style0 from "./groupBuyingAdminView.vue?vue&type=style&index=0&id=4c166562&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports